<template>
	<div data-component="group-header"
		:data-expanded="expanded"
		@click="handleClick"
		tabindex="0">
		<p
			v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
			v-color="this.$store.getters['ui/getPrimaryColor']"
			data-element="group-name"
			:data-bold="expanded"
			:data-size="size"
			v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
		>
			{{ text }}
		</p>
		<div
			data-element="icon-container"
			data-position="right"
			v-if="!noCollapse"
			:data-modal="modal"
		>
			<icon
				icon="collapse-arrow"
				size="sm"
				data-element="icon"
				:class="{ rotated: expanded }"
				alt="Expand/collapse toggle"
			/>
		</div>
	</div>
</template>

<script>
	import Icon from '@/components/ui/Icon';

	export default {
		props: [ 'handleClick', 'expanded', 'text', 'size', 'modal', 'noCollapse' ],
		components: {
			Icon
		}
	}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='group-header'] {
		position:relative;
		display:flex;
		align-items:center;
		height:48px;
		color:$jungle-green;
		font-size:18px;
		font-weight:500;
		line-height:1.33;
		border-bottom:2px solid #9b9b9b;
		transition:1s border-color ease;
		&:focus {
			outline:none;
		}
		&[data-expanded] {
			border-color:rgba(155,155,155,0);
		}
		[data-element='icon'] {
			-webkit-transition: all 0.5s ease-in-out;
			-o-transition: all 0.5s ease-in-out;
			transition: all 0.5s ease-in-out;
			&[data-size='md']  {
				@include whenScreenIs(md) {
					display:none;
				}
			}
			&.rotated {
				-webkit-transform: rotate(180deg);
				-ms-transform: rotate(180deg);
				-o-transform: rotate(180deg);
				transform: rotate(180deg);
			}
		}
		[data-element='icon-container'] {
			position:absolute;
			display:inline-block;
			&:not([data-modal]) {
				@include whenScreenIs(md) {
					display:none;
				}
			}
			&[data-position='right'] {
				right:0;
				top:13px;
			}
			&[data-modal] {
				right:0;
			}
		}
		[data-element='group-name'], [data-element='icon-container']{
			cursor: pointer;
		}
		[data-element='group-name'] {
			&[data-size='md'] {
				@include whenScreenIs(md) {
					font-size:20px;
					font-weight:800;
				}
			}
			&[data-bold] {
				font-weight:bold;
			}
		}
	}
</style>
